
































































import { Object } from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IBank } from '@/store/modules/components/states'
import { ICenter } from '@/store/modules/views/center/states'
import { IUser } from '@/store/modules/views/user/states'

@Component
export default class PaymentHistory extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 10,
    search: '',
  }
  private id = ''
  private name = ''
  private email = ''
  private currentData = {}
  private filters = {}
  private loadingDataTable = true
  private createDialog = false
  private paymentHistoryDialog = false
  private deleteDialog = false
  private resetDialog = false
  private zoomImageDialog = false
  private slipImg = ''
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  @Action('paymentHistory/getPaymentHistoryList')
  private getPaymentHistoryList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('user/getUserList')
  private getUserList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => Promise<void>

  @Getter('components/banks')
  private banks: IBank[]

  @Getter('paymentHistory/headerLists')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('paymentHistory/itemLists')
  private itemLists!: IUser[]

  @Getter('paymentHistory/pagination')
  private pagination!: () => void

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  @Getter('user/userById')
  private userById!: {[userId: string]: IUser}

  private doTransformIconColor(value) {
    switch (value) {
      case 'อนุมัติ': return 'green'
      case 'ปฏิเสธ': return 'red'
      case 'รอตรวจสอบ': return 'yellow'
      default: return 'grey'
    }
  }

  private async callApi(lists) {
    this.loadingDataTable = true
    await lists({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(this.filters)).toString('base64'),
      },
    })
    this.loadingDataTable = false
  }

  private async getPaymentHistories() {
    const list = await this.callApi(this.getPaymentHistoryList)
    const userIds = _.uniq(_.map(this.items, 'userId'))
    await this.getUserList({
      headers: {
        page: 1,
        limit: userIds.length,
        sortBy: '_id',
        sortDesc: false,
        search: Buffer.from('').toString('base64'),
        filter: Buffer.from(JSON.stringify({_id: [{condition: 'is', value: userIds}]})).toString('base64'),
      },
    })
    return list
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(() => this.getPaymentHistories(), 1000)
  }

  private openDialog(paymentHistory: {name: string, email: string, id: string}, modelDialog: 'paymentHistoryDialog') {
    this.currentData = _.cloneDeep(paymentHistory)
    this[modelDialog] = true
  }

  private findBank(bank: string) {
    const result = _.find(this.banks, (b) => b.name === bank)
    return result ? result.text : bank
  }

  private async mounted() {
    await this.getPaymentHistories()
  }
}
